import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import {
  DangerousB,
  DangerousCite,
  DangerousSpan,
} from '../../components/common';
import { ContentContainerJson, HTMLContentJson } from '../../types';
import {
  BlockBackgroundContext,
  PresentModeContext,
} from '../../utils/contexts';
import styles from './Footer.scss';

type FooterProps = {
  footnote?: HTMLContentJson;
  base?: Omit<ContentContainerJson, 'name'>;
  source?: Omit<ContentContainerJson, 'name'>;
  hide?: boolean;
};

const Footer: VFC<FooterProps> = ({ footnote, base, source, hide }) => {
  const presentMode = useContext(PresentModeContext);
  const { darkBg } = useContext(BlockBackgroundContext);

  return (
    <div
      className={classNames(styles.attribution, {
        [styles['present-mode']]: !!presentMode,
        [styles.hide]: hide,
      })}
    >
      {footnote && !footnote.hidden && (
        <Text.Body darkBg={darkBg} underlineLinks>
          <p>
            <DangerousSpan>{footnote.content}</DangerousSpan>
          </p>
        </Text.Body>
      )}
      {base && !base.hidden && base.elements.content && (
        <Text.Body darkBg={darkBg} underlineLinks>
          <p>
            {base.elements.prefix && (
              <>
                <DangerousB>{base.elements.prefix.content}</DangerousB>
                &nbsp;
              </>
            )}
            <DangerousSpan>{base.elements.content.content}</DangerousSpan>
          </p>
        </Text.Body>
      )}
      {source && !source.hidden && source.elements.content && (
        <Text.Body darkBg={darkBg} underlineLinks>
          <p>
            {source.elements.prefix && (
              <>
                <DangerousB>{source.elements.prefix.content}</DangerousB>
                &nbsp;
              </>
            )}
            <DangerousCite>{source.elements.content.content}</DangerousCite>
          </p>
        </Text.Body>
      )}
    </div>
  );
};

export default Footer;
